/* eslint-disable */
// @ts-nocheck
import {
  Button, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, Link as MuiLink, OutlinedInput, TextField, Typography,
} from '@material-ui/core';
import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useStores from '../../hooks/use-stores';
import { useLoginPageStyles } from './LoginPageStyles';
import { LoginState } from '../../models/LoginModels';
import { Visibility, VisibilityOff } from '@material-ui/icons';

export default function InitialForm() {
  const classes = useLoginPageStyles();

  const {
    moovyAuthStore: {
      setPassword,
      setStep,
      signUp,
      mail,
    },
  } = useStores();

  const { t } = useTranslation(['common', 'validation'])

  const passwordValidationSchema = yup.object({
    password: yup
      .string()
      .min(10, t('validation:login.passwordTooShortError'))
      .required(t('validation:general.fieldRequired')),
    passwordRepeat: yup
      .string()
      .oneOf([yup.ref('password'), null], t('validation:general.passwordNoMatch'))
      .required(t('validation:general.fieldRequired')),
  });

  // local state for toggling show/hide password
  const [isHidden, setHidden] = React.useState({
    isHidden: true,
  })

  // local state for toggling show/hide repeat password
  const [isHiddenRep, setHiddenRep] = React.useState({
    isHiddenRep: true,
  })

  // init formik for this component
  const registerPasswordFormik = useFormik({
    initialValues: {
      password: '',
      passwordRepeat: '',
    },
    validationSchema: passwordValidationSchema,
    onSubmit: (values) => {
      setPassword(values.password);
      signUp();
    },
  });

  return (
    <form onSubmit={registerPasswordFormik.handleSubmit} autoComplete="off">
      <Grid
        container
        spacing={2}
        justify="center"
        alignItems="center"
        direction="column"
      >

        <Grid item>
          <Typography variant="h5">
            {t('common:login.registerLabel')}
          </Typography>
        </Grid>

        <Grid item>
          <Typography variant="h6">
            {mail}
          </Typography>
        </Grid>
     
        <Grid item>
          <FormControl variant='outlined'
            error={
              registerPasswordFormik.touched.password
              && Boolean(registerPasswordFormik.errors.password)}>
            <InputLabel htmlFor="password">{t('common:login.password')} </InputLabel>
            <OutlinedInput
              id="password"
              label={t('common:login.password')}
              type={isHidden ? 'password' : 'text'}
              fullWidth
              autoFocus
              className={classes.textfield}
              value={registerPasswordFormik.values.password}
              onChange={registerPasswordFormik.handleChange}
              onBlur={registerPasswordFormik.handleBlur}
              error={
                registerPasswordFormik.touched.password
                && Boolean(registerPasswordFormik.errors.password)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => isHidden ? setHidden(false) : setHidden(true)}
                    edge="end"
                  >
                    {isHidden ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
            <FormHelperText>
              {registerPasswordFormik.touched.password && registerPasswordFormik.errors.password}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl variant='outlined'
            error={registerPasswordFormik.touched.passwordRepeat
              && Boolean(registerPasswordFormik.errors.passwordRepeat)}
          >
            <InputLabel htmlFor="passwordRepeat">{t('common:login.repeatPassword')} </InputLabel>
            <OutlinedInput
              id="passwordRepeat"
              label={t('common:login.repeatPassword')}
              type={isHiddenRep ? 'password' : 'text'}
              fullWidth
              autoFocus
              className={classes.textfield}
              value={registerPasswordFormik.values.passwordRepeat}
              onChange={registerPasswordFormik.handleChange}
              onBlur={registerPasswordFormik.handleBlur}
              helperText={registerPasswordFormik.touched.passwordRepeat
                && registerPasswordFormik.errors.passwordRepeat}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password repeat visibility"
                    onClick={() => isHiddenRep ? setHiddenRep(false) : setHiddenRep(true)}
                    edge="end"
                  >
                    {isHiddenRep ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
            <FormHelperText>
              {registerPasswordFormik.touched.password && registerPasswordFormik.errors.passwordRepeat}
            </FormHelperText>
          </FormControl>
        </Grid>


        <Grid item>
          <Button
            className={classes.button}
            disableElevation
            type="submit"
            size="large"
            variant="contained"
            color="primary"
            fullWidth
          >
            {t('common:login.registerLabel')}
          </Button>
        </Grid>

        <Grid item>
          <MuiLink onClick={() => setStep(LoginState.initial)}>
            {t('common:general.back')}
          </MuiLink>
        </Grid>

        <Grid item>
          <Link to="/help">
            {t('common:login.haveProblemQuestion')}
          </Link>
        </Grid>

      </Grid>
    </form>
  );
}
